import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Stack, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import Block from "@/components/Block";
import type { BookingFormData } from "../Details";

export default function VehicleDetailsForm() {
  const {
    control,
    formState: { errors },
  } = useFormContext<BookingFormData>();

  return (
    <Block flushOnMobile>
      <Typography variant="h3" sx={{ mb: 2 }}>
        <Trans>Vehicle Details</Trans>
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        <Trans>
          If you are traveling by car or motorcycle and know your license plate number, please enter
          it here.
        </Trans>
      </Typography>
      <Stack spacing={2} direction={{ xs: "column", md: "row" }}>
        <Controller
          name="car.license_plate"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              placeholder={t`License Plate`}
              fullWidth
              variant="filled"
              error={!!errors.car?.license_plate}
              helperText={errors.car?.license_plate?.message}
            />
          )}
        />

        <Controller
          name="car.length"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              placeholder={t`Length (m)`}
              type="number"
              fullWidth
              slotProps={{
                input: {
                  inputProps: { step: "0.1", min: "1", max: "50" },
                },
              }}
              variant="filled"
              error={!!errors.car?.length}
              helperText={errors.car?.length?.message}
            />
          )}
        />

        <Controller
          name="car.width"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              placeholder={t`Width (m)`}
              type="number"
              fullWidth
              slotProps={{
                input: {
                  inputProps: { step: "0.1", min: "1", max: "10" },
                },
              }}
              variant="filled"
              error={!!errors.car?.width}
              helperText={errors.car?.width?.message}
            />
          )}
        />
      </Stack>
    </Block>
  );
}
